import { AnagraficaDelegatoDTO } from '@framework/api-client';
import { t } from '@framework/i18n';
import type { ColumnGroupType, ColumnsType, ColumnType } from 'antd/es/table';

type ColumnsBase<TDto> = Record<
  string,
  ColumnGroupType<TDto> | ColumnType<TDto>
>;

export const addressBookColumnsBase: ColumnsBase<AnagraficaDelegatoDTO> = {
  identity: {
    title: t('address-book.columns.identificativo', 'Identificativo'),
    dataIndex: 'id',
    key: 'id',
    render: (_, record) => record.codiceFiscale ?? record.email,
  },
  fiscalCode: {
    title: t('address-book.columns.codice-fiscale', 'Codice Fiscale'),
    dataIndex: 'codiceFiscale',
    key: 'codiceFiscale',
  },
  name: {
    title: t('address-book.columns.nome', 'Nome'),
    dataIndex: 'nome',
    key: 'nome',
    sorter: true,
  },
  surname: {
    title: t('address-book.columns.cognome', 'Cognome'),
    dataIndex: 'cognome',
    key: 'cognome',
    sorter: true,
  },
  fullName: {
    title: t('address-book.columns.nome-completo', 'Nome'),
    key: 'nomeCompleto',
    render: (_, record) => `${record.nome} ${record.cognome}`,
  },
  email: {
    title: t('address-book.columns.email', 'Email'),
    dataIndex: 'email',
    key: 'email',
  },
  address: {
    title: t('address-book.columns.indirizzo', 'Indirizzo'),
    dataIndex: 'indirizzo',
    key: 'indirizzo',
  },
  note: {
    title: t('address-book.columns.note', 'Note'),
    dataIndex: 'note',
    key: 'note',
  },
};

export const addressBookColumns: ColumnsType<AnagraficaDelegatoDTO> = [
  addressBookColumnsBase.identity,
  addressBookColumnsBase.surname,
  addressBookColumnsBase.name,
  addressBookColumnsBase.note,
];

export const modalAddressBookColumns: ColumnsType<AnagraficaDelegatoDTO> = [
  addressBookColumnsBase.identity,
  addressBookColumnsBase.fullName,
  addressBookColumnsBase.note,
];

export const mobileAddressBookColumns: ColumnsType<AnagraficaDelegatoDTO> = [
  addressBookColumnsBase.identity,
  addressBookColumnsBase.fullName,
];
